import { isEmpty } from 'lodash';

const serviceTypeRequiredValidation = (invalidServiceType) => ({
  func: (value = '') => (
    !value && isEmpty(invalidServiceType) ? 'Required' : ''
  ),
});

export default serviceTypeRequiredValidation;
